// extracted by mini-css-extract-plugin
export default {"gridcontainer":"articlesArea_gridcontainer__FREck","grid":"articlesArea_grid__piUHu"};